import {UserAgent} from '@shared/helpers/userAgent'

const getNavigator = () => {
    if (typeof window !== 'undefined') {
        if (window.navigator || navigator) {
            return window.navigator || navigator
        }
    }

    return false
}
const isIOS13Check = (type: string) => {
    const nav = getNavigator()
    return (
        nav &&
        nav.platform &&
        (nav.platform.indexOf(type) !== -1 ||
            (nav.platform === 'MacIntel' &&
                nav.maxTouchPoints > 1 &&
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                !(window as any).MSStream))
    )
}

const getIPad13 = () => !!isIOS13Check('iPad')

class BrowserUserAgent extends UserAgent {
    override get isIOS(): boolean {
        return super.isIOS || getIPad13()
    }

    override get isMobile(): boolean {
        return super.isMobile || getIPad13()
    }

    override get isMobileSafari(): boolean {
        return super.isMobileSafari || getIPad13()
    }

    override get isTablet(): boolean {
        return super.isTablet || getIPad13()
    }
}

// 모듈 로드 시 1회만 생성됨
export const browserUserAgent = new BrowserUserAgent(window.navigator.userAgent)
